import React, { useEffect, useState } from 'react';
import theme from './BookameraIntegration.module.scss';
import { LoadingIndicator, NoResultsCard, SimpleCard } from '@ygtechnologies/bygr-frontend-component-library';
import { useAsyncState } from '@/utils/hooks';
import { getAllServices, saveAllServices } from '@/services/booking';
import { Trans } from '@lingui/react/macro';
import { AlertBanner, Button, ButtonBar, Checkbox } from '@ygtechnologies/rubus-ui';

interface BokameraIntegrationServiceListProps {
    projectId: number;
}

const BokameraIntegrationServiceList = ({ projectId }: BokameraIntegrationServiceListProps) => {
    const [isSavingService, setIsSavingService] = useState(false);
    const [services, , reloadAllServices] = useAsyncState(() => getAllServices(projectId), [projectId], null);
    const [showServices, setShowServices] = useState<{ id: number; name: string; enabled: boolean }[] | null>(null);
    useEffect(() => {
        if (services) {
            setShowServices(
                services?.map((x) => {
                    return {
                        id: x.id,
                        name: x.name,
                        enabled: x.enabled,
                    };
                })
            );
        }
    }, [services]);

    const onEnabled = (id: number) => {
        var service = showServices?.find((x) => x.id === id);
        if (service) service.enabled = !service?.enabled;
        if (showServices) setShowServices([...showServices]);
    };
    const saveServices = async () => {
        if (services && showServices) {
            setIsSavingService(true);

            await saveAllServices(
                projectId,
                services?.map((x) => {
                    const showServiceEntity = showServices.find((y) => y.id === x.id);
                    if (showServiceEntity) return { ...x, enabled: showServiceEntity.enabled };
                    else return { ...x };
                })
            );
            reloadAllServices();
            setIsSavingService(false);
        }
    };
    return (
        <div className={theme.bookameraServices}>
            <h3>
                <Trans>Avaliable services</Trans>
            </h3>
            <AlertBanner type="info" title={<Trans>Select services</Trans>}>
                <Trans>
                    The list below displays all available services from Bokamera. Please select the services you wish to
                    utilize in the integration. The chosen services will be available for buyers to select within the
                    project.
                </Trans>
            </AlertBanner>
            {services === null && <LoadingIndicator />}
            {services?.length == 0 && <NoResultsCard />}
            {services
                ?.sort((x, y) => x.name.localeCompare(y.name))
                .map((x) => (
                    <SimpleCard key={x.id}>
                        <Checkbox
                            inputSize="md"
                            checked={showServices?.find((z) => z.id === x.id)?.enabled}
                            onChange={() => onEnabled(x.id)}>
                            {x.name}
                        </Checkbox>
                    </SimpleCard>
                ))}
            <ButtonBar>
                <ButtonBar.Right>
                    <Button variant="primary" onClick={saveServices} loading={isSavingService}>
                        <Trans>Save</Trans>
                    </Button>
                </ButtonBar.Right>
            </ButtonBar>
        </div>
    );
};
export default BokameraIntegrationServiceList;
